import { Button } from '@mui/material';
import React from 'react';
import './index.scss';

export default function CommonIconButton(props) {
  const {
    onClick,
    text,
    margin,
    disabled,
    type,
    width, minWidth, maxWidth,
    minHeight, maxHeight,
    fontSize,
    padding,
    alignItems,
    backgroundColor,
    border,
    btnColor,
    btnBackgroundColor,
    btnWidth,
    btnHeight,
    btnFontWeight,
    btnFontSize,
    btnBorder,
    btnPadding,
    endIcon,
    startIcon
  } = props;

  const contStyle = () => {
    const style = {};
    if (padding) style.padding = padding;
    if (width) style.width = width;
    if (minWidth) style.minWidth = minWidth;
    if (maxWidth) style.maxWidth = maxWidth;
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    if (fontSize) style.fontSize = fontSize;
    if (margin) style.margin = margin;
    if (border) style.border = border;
    if (backgroundColor) style.backgroundColor = backgroundColor;
    if (alignItems) style.alignItems = alignItems;
    return style;
  };

  const btnStyle = () => {
    const style = {};
    if (btnWidth) style.width = btnWidth;
    if (btnHeight) style.height = btnHeight;
    if (btnFontWeight) style.fontWeight = btnFontWeight;
    if (btnFontSize) style.fontSize = btnFontSize;
    if (btnBorder) style.border = btnBorder;
    if (btnPadding) style.padding = btnPadding;
    if (btnBackgroundColor) style.backgroundColor = btnBackgroundColor;
    if (btnColor) style.color = btnColor;
    return style;
  };

  return (
    <div className="common-icon-button" style={contStyle()}>
      <Button
        type={type}
        disabled={disabled}
        style={btnStyle()}
        endIcon={endIcon}
        startIcon={startIcon}
        onClick={(e) => {
          e.stopPropagation();
          onClick(e);
        }}
      >
        {text}
      </Button>
    </div>
  );
}